import React , {useState , useEffect , useRef} from "react";
import ReactPlayer from "react-player";
import Royalsuitevideo from "../assets/royal Caribbean video (1).mp4";
// import slide3 from "../assets/3.png";
import Navbar from "./Navbar";
import Footer from "./Footer";
import '../royal.css';
import RoyalBanner1 from "../assets/star_of_the_seas_BANNER (3).jpg";
import RoyalBanner2 from "../assets/RCI-Website-Banner.jpg" ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Deal from "./Deal";
import Dealdata from "./Dealdata";
import { faStar} from '@fortawesome/free-solid-svg-icons';
// import Pack from'../assets/Island_Trip.jpg' ;
import Cruise from '../assets/Cruise.jpg';
import Entertain from '../assets/Entertain.jpg';
import Island from '../assets/Island_Trip.jpg';
import Record from '../assets/Guiness_Record.jpg';
import Family from '../assets/Family.jpg';
import Activity from'../assets/Activity2.jpg';
// import Royalship from '../assets/royal-caribbean-ship.jpg'
// import VipSuite from '../assets/vipsuite.jpg'
import Interior1 from '../assets/interior1.jpg';
import Interior2 from '../assets/interior2.jpg';
// import Ocean from '../assets/Oceanview.jpg'
import Ocean1 from '../assets/ocean1.jpg';
import Ocean2 from'../assets/ocean2.jpg';
// import Balcony from '../assets/Balcony.jpg'
import Balcony1 from "../assets/balcony1.jpg";
import Balcony2 from "../assets/balcony2.jpg";
import Balcony3 from "../assets/balcony3.jpg";
import Suite1 from '../assets/RoyalLoftSuite-Livingroom.jpg';
import Suite2 from '../assets/RoyalLoftSuite-MasterBedroomR.jpg';
import Suite3 from '../assets/RoyalLoftSuite-Balcony.jpg';
import Suite4 from '../assets/RoyalLoftSuite-Bedroom.jpg';
import { ReactComponent as Next } from '../assets/next.svg';
import { ReactComponent as Pre } from '../assets/pre.svg';
import ScrolltoTop from "./ScrolltoTop";
import RoyalCaribbeanForm from "./RoyalLeadform";

// import RoyalCaribbeanForm from "./RoyalLeadform";




const Royal =() => {


   // summer adventure

   const [rsindex, rssetIndex] = useState(0); // initial slide index

   const [rscardsPerView, rssetCardsPerView] = useState(2);
 
   // Array of only the selected deals
   const rsselectedDeals = [Dealdata[34], Dealdata[35], Dealdata[36] , Dealdata[37]];
 
   useEffect(() => {
       const rsupdateCardsPerView = () => {
         rssetCardsPerView(window.innerWidth < 768 ? 1 : 2);
       };
       rsupdateCardsPerView();
       window.addEventListener('resize', rsupdateCardsPerView);
       return () => window.removeEventListener('resize', rsupdateCardsPerView);
     }, []);
 
   const rsmaxIndex = rsselectedDeals.length - rscardsPerView;
 
   const rshandlePrev = () => {
     rssetIndex((prev) => (prev <= 0 ? rsmaxIndex : prev - 1));
   };
   
   const rshandleNext = () => {
     rssetIndex((prev) => (prev >= rsmaxIndex ? 0 : prev + 1));
   };
 
   const rsvisibleDeals = rsselectedDeals.slice(rsindex, rsindex + rscardsPerView);
 

    // royal fleet

  const [rrindex, rrsetIndex] = useState(0); // initial slide index
  
  const [rrcardsPerView, rrsetCardsPerView] = useState(3);

  // Array of only the selected deals
  const rrselectedDeals = [Dealdata[6], Dealdata[7], Dealdata[38] , Dealdata[39], Dealdata[40], Dealdata[41], Dealdata[42], Dealdata[43], Dealdata[44], Dealdata[45], Dealdata[46], Dealdata[47], Dealdata[48], Dealdata[49], Dealdata[50], Dealdata[51], Dealdata[52], Dealdata[53], Dealdata[54], Dealdata[55], Dealdata[56], Dealdata[57], Dealdata[58], Dealdata[59], Dealdata[60], Dealdata[61], Dealdata[62], Dealdata[63], Dealdata[64], Dealdata[65]];


  useEffect(() => {
    const rrupdateCardsPerView = () => {
      rrsetCardsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    rrupdateCardsPerView();
    window.addEventListener('resize', rrupdateCardsPerView);
    return () => window.removeEventListener('resize', rrupdateCardsPerView);
  }, []);
  const rrmaxIndex = rrselectedDeals.length - rrcardsPerView;

  const rrhandlePrev = () => {
    rrsetIndex((prev) => (prev <= 0 ? rrmaxIndex : prev - 1));
  };
  
  const rrhandleNext = () => {
    rrsetIndex((prev) => (prev >= rrmaxIndex ? 0 : prev + 1));
  };

  const rrvisibleDeals = rrselectedDeals.slice(rrindex, rrindex + rrcardsPerView);


  //   video play 

  const playerRef = useRef(null);
  const [playing, setPlaying] = useState(false); // Prevent autoplay

  useEffect(() => {
    const handleScroll = () => {
      if (playerRef.current) {
        const internalPlayer = playerRef.current.getInternalPlayer();
        if (internalPlayer && typeof internalPlayer.pauseVideo === 'function') {
          internalPlayer.pauseVideo();
          setPlaying(false); // Make sure state reflects that playback stopped
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const playerRef2 = useRef(null);
  const [playing2, setPlaying2] = useState(false); // Prevent autoplay

  useEffect(() => {
    const handleScroll2 = () => {
      if (playerRef2.current) {
        const internalPlayer = playerRef2.current.getInternalPlayer();
        if (internalPlayer && typeof internalPlayer.pauseVideo === 'function') {
          internalPlayer.pauseVideo();
          setPlaying2(false); // Make sure state reflects that playback stopped
        }
      }
    };

    window.addEventListener('scroll', handleScroll2);

    return () => {
      window.removeEventListener('scroll', handleScroll2);
    };
  }, []);
  

    return(
        <>
        <Navbar/>
        <div className="header">
            <div className="offer-alert">
                <div>
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                </div>
                <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
            </div>


            <div class= "ajslider royal-slider-main" >
            <div id="carouselExampleIndicators" class="carousel slide royal-header " data-bs-ride="carousel" data-bs-interval="3000">

           {/* <div className="royal-image">
            <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a>
            </div> */}

  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
    <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer">
      <img src={RoyalBanner1} class="d-block w-100" alt="..." style={{ height:'82vh'}}/>
    </a>
    </div>
    <div class="carousel-item">
    <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer">
      <img src={RoyalBanner2} class="d-block w-100" alt="..." style={{ height:'82vh'}}/>
    </a>
    </div>
    {/* <div class="carousel-item">
      <img src={slide3} class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src={slide4} class="d-block w-100" alt="..."/>
    </div> */}
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>

<div className="Royalquote">
 <RoyalCaribbeanForm /> 
 </div>

</div>
 

        </div>
        <div className="royal-caribbean royal-maincontent">
            <p>TIRUN Travel Marketing and Royal Caribbean International pioneered Cruising in India 30 Years ago.</p>
            <p>We have brought Royal Caribbean's unparalleled vacation experiences on the largest, most innovative ships in the world to ours parts. Set sail on the most innovative fleet and discover new experiences, award winning entertainment, global cuisine including Indian Vegetarian and exhilarating activities for the whole family. There's never been more reasons to cruise. Come select your preferred itinerary and make memories that last a lifetime.</p>
        </div>

        <div className="royal-adventure"> 
            
            <div className="content">
            <h2>SUMMER ADVENTURES</h2>
            <p>Embark on the journey of a lifetime as we take you to some of the most captivating destinations around the world. Carefully curated itineraries offer an unforgettable summer experience, exploring the breathtaking beauty and diverse cultures of Alaska, the Mediterranean, the Caribbean, and the Bahamas.</p>
            </div>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[5].img } Dealname={Dealdata[5].Dealname}  /></a>
        </div> */}

        <div className="carousel-wrapper" >
        <button onClick={rshandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {rsvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={rshandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>
        </div>

        

        {/* <div className="royal-package">
            <h2 className="Heading">Adventure for the Whole Pack</h2>
            <img src={Pack} alt="Booking Package" />
            <div style={{backgroundColor:'#00000030',padding:'5vh', width:'100vw', height:'30vh'}}> 
            <h2>PERFECT DAY AT COCOCAY</h2>
            <p>Royal Caribbean's Private Island in Bahamas</p>
            <button>View Itineraries</button>
            </div>
        </div>  */}


        <div className="royal-experience"  id="royal-expe">

            <h2>THE ROYAL CARIBBEAN EXPERIENCE</h2>

            <div className="royal-exp-card">
            <div className="experience">
            <img src={Cruise} alt="royal-caribbean-experience" />
            <p>Largest Cruise Ships in the World</p>
            </div>
            <div className="experience exceptional">
            <img src={Entertain} alt="royal-caribbean-experience" />
            <p>Only Cruise Line with entertainment on stage/water and ice</p>
            </div>
            <div className="experience">
            <img src={Island} alt="royal-caribbean-experience" />
            <p>Private Island - Perfect day at CoCoCay</p>
            </div>
            </div>

            <div className="royal-exp-card">   
            <div className="experience">
            <img src={Record} alt="royal-caribbean-experience"  />
            <p>Guinness World Record Holder- Northstar</p>
            </div>
            <div className="experience">
            <img  src={Family} alt="royal-caribbean-experience" />
            <p>Multi generational with something for everyone</p>
            </div>
            <div className="experience">
            <img src={Activity} alt="royal-caribbean-experience" />
            <p>Introduced Industry First Activities</p>
            </div>
            </div>
            
        </div>


        <div className="royal-adventure"> 
            
            <div className="content">
            <h2>ROYAL CARIBBEAN, UNLEASH YOUR WANDERLUST AT
            SEA!</h2>
            <p>Experience unparalleled thrills and entertainment on some the newest, largest and most innovative ships as you sail the seven seas</p>
            </div>
        <div className="ship">
          {/* <img src={Royalship} alt="Royal Caribbean at Sea" /> */}
            <ReactPlayer
                ref={playerRef}
                url="https://www.youtube.com/watch?v=hYyDSH2ONK4"
                width="750px"
                height="450px"
                controls={true}
                muted={true}
                playing={playing}
                id="short-video"
                className="royal-video-laptop"
              />
        </div>
        <ReactPlayer
                url="https://www.youtube.com/watch?v=hYyDSH2ONK4"
                ref={playerRef2}
                controls={true}
                muted={true}
                playing={true} 
                id="short-video"
                playing2={playing2}
                className="royal-video-mobile"
              />

        </div>

        
        <div className="royal-adventure royal-suite royal-world" > 
            
            <div className="content">
            <h2>CRUISE THE WORLD LIKE VIP</h2>
            <p>Experience the most immersive luxury experiences with Royal Caribbean's Royal Suite Class Program. From the most exquisitely-appointed accommodations to the best-in-class on-board amenities, the suite-tier program promises an experience that is exclusive. With three service levels, Star Class, Sky Class and Sea Class, you can choose the amenities and special touches according to your specific preferences. Personalized service and the Royal Genie, together make up the most indulgent and exciting cruise holiday ever! After all, luxury is anything but boring.</p>
            </div>
        <div className="suite">
          {/* <img src={VipSuite} alt="Royal Caribbean at Sea" /> */}
              <video style={{ width: '750px', height: '450px',objectFit: 'cover' }} controls loop  className="royal-suite-video-laptop">
                  <source src={Royalsuitevideo} type="video/mp4" />
                </video>
          
        </div>
        <video style={{ width: '100%', objectFit: 'fill' }} controls loop  className="royal-suite-video-mobile">
                  <source src={Royalsuitevideo} type="video/mp4" />
                </video>

{/*         
        <div class= "Royal-suite-container">
            <div id="carouselExampleIndicators" class="carousel slide Celebrity-suite-carousel">


        <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={VipSuite} class="d-block w-100" alt="..." style={{height:'450px'}} />
    </div>
    <div class="carousel-item">
      <img src={VipSuite} class="d-block w-100" alt="..." style={{height:'450px'}} />
    </div>
    <div class="carousel-item">
      <img src={VipSuite} class="d-block w-100" alt="..." style={{height:'450px'}} />
    </div>
    <div class="carousel-item">
      <img src={VipSuite} class="d-block w-100" alt="..." style={{height:'450px'}}/>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>
  </div> */}


        </div>



        <div className="Cabin-container royal-container-ex" >

            <h2>ACCOMODATION</h2>

            <div className="Cabin laptop-repsonsive-cabin-royal">
            <div className="royal-cabin">
                
                <div className="cabin-category">  

                <div id="carouselExampleIndicators3" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Interior1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Interior2} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Inside Cabin
                </div>
                </div>

                <div className="cabin-category"> 
                <div id="carouselExampleIndicators4" class="carousel slide">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Ocean1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Ocean2} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div> 
                {/* <img src={Ocean} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Ocean View
                </div>
                </div>
            </div>

            <div className="royal-cabin">

            <div className="cabin-category">  
            <div id="carouselExampleIndicators5" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={Balcony1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Balcony2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Balcony3} class="d-block w-100" alt="..." />
</div>
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Balcony
                </div>
                </div>

                <div className="cabin-category"> 
                <div id="carouselExampleIndicators6" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="2" aria-label="Slide 3"></button>
<button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button>

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Suite1} class="d-block " alt="..."  />
</div>
<div class="carousel-item">
<img src={Suite2} class="d-block " alt="..."  />
</div>
<div class="carousel-item">
<img src={Suite3} class="d-block " alt="..." />
</div>
<div class="carousel-item">
<img src={Suite4} class="d-block w-100" alt="..." />
</div>
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div> 
                {/* <img src={Suite} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Suite
                </div>

                </div>


            </div>

            </div>
            
        </div>


        {/* mobile accomodation */}

        <div className="mobile-accomodation-container">

        <div className="cabin-category mobile-responsive-royal-category">  

                <div id="carouselExampleIndicators7" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Interior1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Interior2} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Inside Cabin
                </div>
                </div>

                <div className="cabin-category mobile-responsive-royal-category"> 
                <div id="carouselExampleIndicators8" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Ocean1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Ocean2} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div> 
                {/* <img src={Ocean} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Ocean View
                </div>
                </div>


                <div className="cabin-category mobile-responsive-royal-category">  
            <div id="carouselExampleIndicators9" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="2" aria-label="Slide 3"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={Balcony1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Balcony2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Balcony3} class="d-block w-100" alt="..." />
</div>
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Balcony
                </div>
                </div>

                <div className="cabin-category mobile-responsive-royal-category"> 
                <div id="carouselExampleIndicators10" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="2" aria-label="Slide 3"></button>
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="3" aria-label="Slide 4"></button>

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Suite1} class="d-block " alt="..."  />
</div>
<div class="carousel-item">
<img src={Suite2} class="d-block " alt="..."  />
</div>
<div class="carousel-item">
<img src={Suite3} class="d-block " alt="..." />
</div>
<div class="carousel-item">
<img src={Suite4} class="d-block w-100" alt="..." />
</div>
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div> 
                {/* <img src={Suite} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Suite
                </div>

                </div>

                </div>


        <div className="royal-adventure royal-fleet" style={{marginBottom:'40vh'}}> 
            
            <div className="content royal-fleet-content">
            <h2>THE ROYAL FLEET</h2>
            <p>Our cruises engage people to sail beyong their own borders and expand their horizons.</p>
            </div>
        {/* <div className="trip" style={{marginBottom:'40vh'}}>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer">  <Deal img={Dealdata[6].img } Dealname={Dealdata[6].Dealname}  /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[7].img } Dealname={Dealdata[7].Dealname}  /></a>

        </div> */}

        <div className="carousel-wrapper" >
        <button onClick={rrhandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {rrvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={rrhandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>

        

        </div>


        <ScrolltoTop/>

        <Footer/>
        </>
    );

}

export default Royal;